import { TreeNode } from "./tree-node.js";
export function createTree(data, options = {
    createRootNode: false,
}) {
    const isArray = Array.isArray(data);
    if (isArray && (options === null || options === void 0 ? void 0 : options.createRootNode)) {
        return new TreeNode({ value: undefined, children: data });
    }
    else if (isArray && !options.createRootNode) {
        return data === null || data === void 0 ? void 0 : data.map((d) => new TreeNode(d));
    }
    else {
        return new TreeNode(data);
    }
}
//# sourceMappingURL=create-tree.js.map